import _ from 'lodash';
import AccessMode from './AccessMode';
import ActionCustomCommandType from './ActionCustomCommandType';
import ActionScheduledExecutionType from './ActionScheduledExecutionType';
import BuilderElementType from './BuilderElementType';
import ActionInstanceStatus from './ActionInstanceStatus';
import ActionIterationDataSource from './ActionIterationDataSource';
import ActionIterationStringDataSource from './ActionIterationStringDataSource';
import ActionOverdueOperation from './ActionOverdueOperation';
import ActionType from './ActionType';
import ActionTypeString from './ActionTypeString';
import ActionUserInstanceUserOperationType from './ActionUserInstanceUserOperationType';
import ActionUserInstanceUserOperationTypeStatus from './ActionUserInstanceUserOperationTypeStatus';
import AIProvider from './AIProvider';
import AIConsumptionSource from './AIConsumptionSource';
import ApiCallParameterCodification from './ApiCallParameterCodification';
import ApiParameterPosition from './ApiParameterPosition';
import ApiSendParameterPosition from './ApiSendParameterPosition';
import ApplicationPage from './ApplicationPage';
import ApplicationResponseStatus from './ApplicationResponseStatus';
import AttachmentFileTypeClassification from './AttachmentFileTypeClassification';
import AttachmentFileTypeClassificationStatus from './AttachmentFileTypeClassificationStatus';
import AttachmentInstanceTypeStatus from './AttachmentInstanceTypeStatus';
import AttachmentMappingValueSource from './AttachmentMappingValueSource';
import AuthorizationType from './AuthorizationType';
import AutomyAIHandlerType from './AutomyAIHandlerType';

import BulkActionType from './BulkActionType';
import BulkRequestTaskStatus from './BulkRequestTaskStatus';

import ComparisonOperator from './ComparisonOperator';
import ConditionalValueSource from './ConditionalValueSource';
import ConnectionType from './ConnectionType';
import CustomListCommandType from './CustomListCommandType';
import CustomListDataOrigin from './CustomListDataOrigin';
import CustomListFieldType from './CustomListFieldType';
import CustomListInternalTaskOperationType from './CustomListInternalTaskOperationType';
import CustomListPreFilterType from './CustomListPreFilterType';
import CustomListType from './CustomListType';

import DatabaseType from './DatabaseType';
import DayOfWeek from './DayOfWeek';
import DelegatedTaskStatus from './DelegatedTaskStatus';
import DelegationStatus from './DelegationStatus';
import DelegationType from './DelegationType';
import DigitalSignaturePosition from './DigitalSignaturePosition';
import DynamicEntityInternalTaskOperationType from './DynamicEntityInternalTaskOperationType';
import DynamicEntityOperation from './DynamicEntityOperation';
import DynamicEntityStringOperation from './DynamicEntityStringOperation';
import DocumentSource from './DocumentSource';

import EmailMessageType from './EmailMessageType';
import EmailTemplateType from './EmailTemplateType';
import EntityQueryOperationType from './EntityQueryOperationType';
import EntityQuerySourceOperationType from './EntityQuerySourceOperationType';
import EnvironmentClassification from './EnvironmentClassification';
import ExportFormInstanceDataSourceFilter from './ExportFormInstanceDataSourceFilter';
import ExternalUserValueSource from './ExternalUserValueSource';

import FileType from './FileType';
import FormFieldBehavior from './FormFieldBehavior';
import FormFieldColumnWidth from './FormFieldColumnWidth';
import FormFieldStringType from './FormFieldStringType';
import FormFieldType from './FormFieldType';
import FormPublicStyleTemplateType from './FormPublicStyleTemplateType';
import FormTableCommand from './FormTableCommand';
import FormTableCommandBehavior from './FormTableCommandBehavior';
import FormTableMode from './FormTableMode';
import FtpAuthenticationMode from './FtpAuthenticationMode';
import FtpFileTransferType from './FtpFileTransferType';

import GoogleIntegrationOperationType from './GoogleIntegrationOperationType';
import HttpMethod from './HttpMethod';
import InternalFieldType from './InternalFieldType';
import InternalOperationEntity from './InternalOperationEntity';
import InternalOperationType from './InternalOperationType';
import InternalTaskStatus from './InternalTaskStatus';
import ItemsAffected from './ItemsAffected';
import JsonDataCreatorResourceType from './JsonDataCreatorResourceType';
import LocaleType from './LocaleType';
import LogicalOperator from './LogicalOperator';

import MailEvent from './MailEvent';
import MappingFormFieldValueDestination from './MappingFormFieldValueDestination';
import MappingValueDestination from './MappingValueDestination';
import MappingValueSource from './MappingValueSource';
import MathOperationType from './MathOperationType';
import MonthName from './MonthName';
import McpConnectionType from './McpConnectionType';

import PageOrientation from './PageOrientation';
import PaperType from './PaperType';
import PlainTextFileFormat from './PlainTextFileFormat';
import PlanType from './PlanType';
import PortalMenuItemType from './PortalMenuItemType';
import ProcessConfigItemType from './ProcessConfigItemType';
import ProcessEngineInternalTaskOperationType from './ProcessEngineInternalTaskOperationType';
import ProcessEngineVersion from './ProcessEngineVersion';
import ProcessInstanceApprovalOrigin from './ProcessInstanceApprovalOrigin';
import ProcessInstanceApprovalOriginStatus from './ProcessInstanceApprovalOriginStatus';
import ProcessInstanceCreatorResourceType from './ProcessInstanceCreatorResourceType';
import ProcessInstanceRequestOrigin from './ProcessInstanceRequestOrigin';
import ProcessInstanceSignalRMessage from './ProcessInstanceSignalRMessage';
import ProcessInstanceStatus from './ProcessInstanceStatus';
import ProcessStartMode from './ProcessStartMode';
import ProgrammingLanguage from './ProgrammingLanguage';

import ReferenceSourceEntity from './ReferenceSourceEntity';
import ReferenceSourceItemType from './ReferenceSourceItemType';
import ReportPlatform from './ReportPlatform';
import ReportType from './ReportType';
import RequestDetailCommandType from './RequestDetailCommandType';
import RequestStatusType from './RequestStatusType';
import RequestsCommentsAccessMode from './RequestsCommentsAccessMode';
import ResponseHttpStatusCode from './ResponseHttpStatusCode';
import RpaAgentPlatform from './RpaAgentPlatform';
import RpaAgentStatus from './RpaAgentStatus';
import RpaInstanceResponseStatus from './RpaInstanceResponseStatus';
import RpaInstanceSendStatus from './RpaInstanceSendStatus';
import RunCodeOperationStatus from './RunCodeOperationStatus';

import ServerType from './ServerType';
import SharePointOperation from './SharePointOperation';
import SignalRMessageType from './SignalRMessageType';

import SocketProcessInstanceMessageType from './SocketProcessInstanceMessageType';
import TaskCreatorType from './TaskCreatorType';
import TaskImportance from './TaskImportance';
import TaskListType from './TaskListType';
import TaskStatus from './TaskStatus';
import TaskType from './TaskType';
import TemplateGenerationFormat from './TemplateGenerationFormat';
import TextFormat from './TextFormat';
import TraceActor from './TraceActor';
import TraceOperation from './TraceOperation';
import TwoFactorProvider from './TwoFactorProvider';
import TableDefaultSortMode from './TableDefaultSortMode';

import UserAccessLogOperationType from './UserAccessLogOperationType';
import UserAccessType from './UserAccessType';
import UserBusinessContext from './UserBusinessContext';
import UserCustomTaskListType from './UserCustomTaskListType';
import UserDisplayValue from './UserDisplayValue';
import UserRole from './UserRole';
import VariableType from './VariableType';

import WebhookMappingValueDestination from './WebhookMappingValueDestination';
import WhatsAppBusinessIntegrationOperationType from './WhatsAppBusinessIntegrationOperationType';
import WizardOrientation from './WizardOrientation';
import WizardStepStyle from './WizardStepStyle';

import ColumnOrderDirection from './ColumnOrderDirection';
import FrequencyUnit from './FrequencyUnit';
import OpenAIRunStatus from './OpenAIRunStatus';
import OpenAIResponsesReasoningEffort from './OpenAIResponsesReasoningEffort';
import OpenAIResponsesReasoningSummary from './OpenAIResponsesReasoningSummary';
import OpenAIMessageToolType from './OpenAIMessageToolType';
import PiiEntityType from './PiiEntityType';
import PiiAction from './PiiAction';
import GuardrailsUrlFilterAction from './GuardrailsUrlFilterAction';
import GuardrailsUrlFilterMode from './GuardrailsUrlFilterMode';
import OperationResultStatus from './OperationResultStatus';
import ResponseGroupingType from './ResponseGroupingType';

// Chat
import ChatAssignmentMode from './ChatAssignmentMode';
import ChatAttentionChannelType from './ChatAttentionChannelType';
import ChatHandlerType from './ChatHandlerType';
import ChatControlMode from './ChatControlMode';
import ChatMessageContentItemType from './ChatMessageContentItemType';
import ChatMessageStatus from './ChatMessageStatus';
import ChatMessageType from './ChatMessageType';
import ChatThreadStatus from './ChatThreadStatus';
import ChatType from './ChatType';
import FtpOperationType from './FtpOperationType';
import NotificationPriority from './NotificationPriority';
import NotificationType from './NotificationType';
import SocketChannels from './SocketChannels';
import SocketMessageType from './SocketMessageType';

function toStrCase(key, strCase) {
  return {
    default: key,
    camel: _.camelCase(key),
    snake: _.snakeCase(key),
    kebab: _.kebabCase(key),
    title: _.chain(key).kebabCase().split('-').startCase().value(),
  }[strCase];
}

function reversePair(key, options) {
  const keyName = toStrCase(key, options.case);
  return options.prefix ? `${options.prefix}.${keyName}` : keyName;
}

export function reverseEnumerator(obj, options = { case: 'default', prefix: null }) {
  return _.toPairs(obj).reduce((lhs, [key, num]) => {
    return {
      ...lhs,
      [num]: reversePair(key, options),
    };
  }, {});
}

export function transformEnumeratorKeys(obj, options = { case: 'default' }) {
  return _.toPairs(obj).reduce((lhs, [key, num]) => {
    return {
      ...lhs,
      [toStrCase(key, options.case)]: num,
    };
  }, {});
}

const CoreEnums = (function () {
  return {
    ActionCustomCommandType,
    ActionInstanceStatus,
    ActionScheduledExecutionType,
    ActionType,
    ActionTypeString,
    ActionUserInstanceUserOperationType,
    ActionUserInstanceUserOperationTypeStatus,
    AttachmentFileTypeClassification,
    AttachmentFileTypeClassificationStatus,
    AttachmentInstanceTypeStatus,
    AuthorizationType,
    ApiSendParameterPosition,
    ApiParameterPosition,
    ApiCallParameterCodification,
    AttachmentMappingValueSource,
    ActionIterationDataSource,
    ActionIterationStringDataSource,
    ActionOverdueOperation,
    ApplicationPage,
    ApplicationResponseStatus,
    AutomyAIHandlerType,
    AccessMode,
    AIProvider,
    AIConsumptionSource,

    BuilderElementType,
    BulkActionType,
    BulkRequestTaskStatus,

    ComparisonOperator,
    CustomListCommandType,
    CustomListFieldType,
    CustomListInternalTaskOperationType,
    CustomListPreFilterType,
    CustomListType,
    CustomListDataOrigin,
    ConditionalValueSource,
    ConnectionType,
    DatabaseType,
    DayOfWeek,
    DelegationStatus,
    DynamicEntityInternalTaskOperationType,
    DynamicEntityOperation,
    DynamicEntityStringOperation,
    DigitalSignaturePosition,
    DelegationType,
    DelegatedTaskStatus,
    DocumentSource,

    EmailTemplateType,
    EnvironmentClassification,
    EntityQuerySourceOperationType,
    EmailMessageType,
    EntityQueryOperationType,
    ExportFormInstanceDataSourceFilter,
    ExternalUserValueSource,

    FileType,
    FormFieldBehavior,
    FormFieldColumnWidth,
    FormFieldType,
    FormFieldStringType,
    FormPublicStyleTemplateType,
    FtpOperationType,
    FormTableCommand,
    FormTableCommandBehavior,
    FormTableMode,
    FtpFileTransferType,
    FtpAuthenticationMode,

    GoogleIntegrationOperationType,
    HttpMethod,
    InternalFieldType,
    InternalOperationEntity,
    InternalOperationType,
    InternalTaskStatus,
    ItemsAffected,
    JsonDataCreatorResourceType,
    LogicalOperator,
    LocaleType,

    MathOperationType,
    McpConnectionType,
    MailEvent,
    MappingFormFieldValueDestination,
    MappingValueSource,
    MappingValueDestination,
    MonthName,

    PageOrientation,
    PaperType,
    ProcessConfigItemType,
    ProcessEngineInternalTaskOperationType,
    ProcessInstanceApprovalOrigin,
    ProcessInstanceApprovalOriginStatus,
    ProcessInstanceCreatorResourceType,
    ProcessInstanceRequestOrigin,
    ProcessInstanceStatus,
    ProcessStartMode,
    ProcessInstanceSignalRMessage,
    PlanType,
    PlainTextFileFormat,
    PortalMenuItemType,
    ProcessEngineVersion,
    ProgrammingLanguage,

    ReportType,
    ReportPlatform,
    RequestDetailCommandType,
    RequestStatusType,
    RequestsCommentsAccessMode,
    ResponseHttpStatusCode,
    RpaAgentPlatform,
    RpaAgentStatus,
    RpaInstanceResponseStatus,
    RpaInstanceSendStatus,
    RunCodeOperationStatus,
    ReferenceSourceItemType,
    ReferenceSourceEntity,

    SharePointOperation,
    SignalRMessageType,
    SocketProcessInstanceMessageType,
    ServerType,

    TraceActor,
    TwoFactorProvider,
    TemplateGenerationFormat,
    TaskType,
    TaskListType,
    TaskStatus,
    TaskImportance,
    TaskCreatorType,
    TraceOperation,
    TextFormat,
    TableDefaultSortMode,

    UserAccessType,
    UserAccessLogOperationType,
    UserDisplayValue,
    UserBusinessContext,
    UserRole,
    UserCustomTaskListType,
    VariableType,

    WhatsAppBusinessIntegrationOperationType,
    WebhookMappingValueDestination,
    WizardOrientation,
    WizardStepStyle,
    FrequencyUnit,
    OpenAIRunStatus,
    OpenAIResponsesReasoningEffort,
    OpenAIResponsesReasoningSummary,
    OpenAIMessageToolType,
    PiiEntityType,
    PiiAction,
    GuardrailsUrlFilterAction,
    GuardrailsUrlFilterMode,
    OperationResultStatus,

    ResponseGroupingType,
    ColumnOrderDirection,

    // chat
    ChatAssignmentMode,
    ChatType,
    ChatThreadStatus,
    ChatMessageType,
    ChatMessageStatus,
    ChatMessageContentItemType,
    ChatHandlerType,
    ChatControlMode,
    ChatAttentionChannelType,
    SocketMessageType,
    SocketChannels,
    NotificationPriority,
    NotificationType,
  };
})();

export default CoreEnums;
